export const PORTAL_COLORS = {
  pendingDocuments: '#d6828a',
  unreadMessages: '#7fadea',
};